import React from "react";
import { useMutation, useQuery } from "@apollo/client";
import { message, Space, Table, Button } from "antd";

import {
  COLLABORATORS_QUERY,
  REMOVE_COLLABORATOR_MUTATION,
} from "../../helpers/graphql/collaborator";
import { InviteCollaborator } from "../collaborators/InviteCollaborator";

interface Props {
  project: { id: string };
}

interface Collaborator {
  email: string;
  githubId: string;
  id: string;
  verified: boolean;
}

export function Collaborators({ project }: Props) {
  const { loading, data } = useQuery(COLLABORATORS_QUERY, {
    variables: {
      projectId: project.id,
    },
  });

  const [removeCollaborator, { loading: removeLoading }] = useMutation(
    REMOVE_COLLABORATOR_MUTATION,
    {
      onCompleted: () => {
        message.success("Removed collaborator!");
      },
      refetchQueries: () => [
        {
          query: COLLABORATORS_QUERY,
          variables: {
            projectId: project.id,
          },
        },
      ],
    },
  );

  const collaborators = data?.collaborators;

  const columns = [
    {
      title: "Github ID",
      dataIndex: "githubId",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Action",
      key: "action",
      render: (record: Collaborator) =>
        collaborators?.length > 1 ? (
          <Space size="middle">
            <Button
              loading={removeLoading}
              type="link"
              onClick={() =>
                removeCollaborator({ variables: { projectId: project.id, userId: record.id } })
              }
            >
              Delete
            </Button>
          </Space>
        ) : null,
    },
  ];

  return (
    <>
      <InviteCollaborator project={project} />
      <Table
        style={{ marginTop: 15 }}
        loading={loading}
        columns={columns}
        dataSource={collaborators}
        rowKey={(row) => row.id}
      />
    </>
  );
}
